/**
 * Fachliche Grundtypen der Artikelstruktur.
 *
 * Quelle der Wertevorraete: greenius-BASE-Wissen
 *   - PRODUCT_PRICE_V1.md, Abschnitt 2.6  (Produktkategorien)
 *   - PRODUCT_PRICE_V1.md, Abschnitt 5    (Status, Qualitaet)
 *   - PRODUCT_PRICE_V1.md, Abschnitt 9a.3 (Artikelrollen)
 *
 * Diese Datei erfindet keine Werte. Sie bildet die dort verankerten ab.
 */
/** Die zehn Produktkategorien nach PRODUCT_PRICE_V1.md, Abschnitt 2.6. */
export const PRODUCT_CATEGORY_CODES = [
    "highbay",
    "triproof",
    "panel",
    "linear",
    "downlight",
    "tracklight",
    "area_outdoor",
    "notlicht",
    "komponenten",
    "office",
];
/** Artikelrollen nach PRODUCT_PRICE_V1.md, Abschnitt 9a.3. Additiv, mehrfach zulaessig. */
export const ARTICLE_ROLE_CODES = [
    "hauptprodukt",
    "komponente",
    "zubehoer",
    "ersatzteil",
    "option",
];
/**
 * Artikelstatus nach PRODUCT_PRICE_V1.md, Abschnitt 5.1.
 *
 * `null` bedeutet ausdruecklich "nicht bestimmt" und ist kein fuenfter Status.
 * Fuer den Erstimport gilt Abschnitt 9a.1: ist der Status nicht belastbar
 * bestimmbar, wird keiner erfunden.
 */
export const LIFECYCLE_STATUS_CODES = [
    "aktiv",
    "auslaufend",
    "inaktiv",
    "nicht_freigegeben",
];
/** Qualitaetsstatus nach PRODUCT_PRICE_V1.md, Abschnitt 5.2. */
export const QUALITY_STATUS_CODES = ["belastbar", "warnung", "pruefung_erforderlich"];
/**
 * Migrationspruefhinweise nach PRODUCT_PRICE_V1.md, Abschnitt 5.4.
 *
 * Ausdruecklich weder Status- noch Rollenwerte. Temporaer, mehrere
 * gleichzeitig je Artikel moeglich, entfernbar ohne den Status zu beruehren.
 */
export const REVIEW_FLAG_CODES = [
    "erststatus_zu_pruefen",
    "produktfamilie_zu_pruefen",
    "rolle_zu_pruefen",
    "zollsatz_zu_pruefen",
    "verpackungsdaten_fehlen",
    "artikelnummer_konflikt",
    "supplier_schreibweise",
    "fracht_ohne_volumen",
    // Migration 0010: die Artikelnummer koennte einen Platzhalter enthalten.
    // Eine offene FRAGE, keine Antwort -- die Bedeutung ist ausserhalb von
    // AREA PRO FL nicht bestaetigt (PRODUCT_DATA_MODEL.md 3.7).
    "platzhalter_zu_pruefen",
];
/**
 * Sprachneutrale Produktkategorien.
 *
 * Ein Wert bleibt sprachneutral, wenn er einen Gegenstand BENENNT statt ihn zu
 * BESCHREIBEN (TERMINOLOGY_DE_EN.md, Klasse A). Diese acht tragen bereits
 * englische oder international gebraeuchliche Namen und werden in beiden
 * Sprachen unveraendert angezeigt.
 *
 * Die beiden uebrigen -- `notlicht` und `komponenten` -- sind beschreibende
 * deutsche Fachbegriffe und besitzen eine freigegebene englische Anzeige im
 * Woerterbuch. Diese Liste ist die technische Gegenprobe: was hier nicht
 * steht, MUSS uebersetzt sein, sonst schlaegt die Sprachpruefung fehl.
 */
export const LANGUAGE_NEUTRAL_CATEGORY_CODES = [
    "highbay", "triproof", "panel", "linear",
    "downlight", "tracklight", "area_outdoor", "office",
];
/**
 * Sprachneutrale Produktfamilien.
 *
 * Der kanonische Familienname ist zugleich der Code. Die hier gefuehrten
 * Namen sind Produktbezeichnungen -- Eigennamen, Modell- und Seriencodes --
 * und werden nicht uebersetzt.
 *
 * Nicht enthalten und deshalb uebersetzt: `Treiber` und
 * `LED-Notlichtbeleuchtung`. Beide beschreiben einen Gegenstand, statt ihn zu
 * benennen.
 *
 * Fachliche Quelle der Klassifizierung: TERMINOLOGY_DE_EN.md, Abschnitt 7.
 */
export const LANGUAGE_NEUTRAL_FAMILY_CODES = [
    "AREA POLLER 180", "AREA POLLER 360", "AREA PRO", "AREA PRO FL", "AREA PRO HF",
    "AREA SPORT", "AREA SPORT II", "FL ATEX", "WALLPACK", "WALLPACK Q",
    "HB ATEX", "HB FLAT", "HB NSF", "HB PRO", "HB UGR",
    "TP ATEX", "TP LiteLine", "TP PRO", "TP TUBE",
    "LB PRO", "LB UGR", "RetroFix",
    "TRACKLIGHT", "TRACKLIGHT KONTUR", "TRACKLIGHT SVIVEL", "TRACKLIGHT TG", "TRACKLIGHT VARIOZOOM",
    "PANEL",
    "HANNA", "LUCY", "MARCI", "MIRA",
    // Bewusst sprachneutral belassen, obwohl gemischtsprachig:
    "Downlights / D-Serie", "LL-System",
];
/** Herkunft einer Angabe (HOMEBASE_ARCHITECTURE.md, Abschnitt 10). */
export const PROVENANCE_KINDS = ["quelle", "abgeleitet", "bestaetigt"];
/** Art einer Artikelnummer (HOMEBASE_ARCHITECTURE.md, Abschnitt 7.1). */
export const ARTICLE_NUMBER_KINDS = ["aktuell", "historisch", "alternativ"];
/**
 * Redaktionelle Produkttexte (Migration 0007).
 *
 * Die Wertevorraete stammen aus dem freigegebenen Fachmodell. Diese Datei
 * erfindet keine Werte -- sie bildet die entschiedenen ab.
 */
/** Die sechs freigegebenen Texttypen V1. `marketingtext` gehoert nicht dazu. */
export const TEXT_TYPE_CODES = [
    "artikelname",
    "kurzbeschreibung",
    "langtext",
    "ausschreibungstext",
    "anwendung",
    "hinweis",
];
/** Sprachen der redaktionellen Texte. V1: Deutsch und Englisch. */
export const TEXT_LANGUAGE_CODES = ["de", "en"];
/** WOHER eine Sprachfassung stammt. */
export const TEXT_ORIGINS = ["supplier", "intern", "import", "extern"];
/**
 * WIE eine Sprachfassung entstand.
 *
 * Bewusst getrennt von der Herkunft: eine KI-Uebersetzung eines
 * Supplier-Originals ist intern entstanden, aber maschinell uebersetzt.
 */
/*
 * Ein ERZEUGTER Text ist keine Uebersetzung, sondern ein Original -- deshalb
 * zwei eigene Wege und keine Erweiterung von `uebersetzt_ki`. Der Unterschied
 * zwischen den beiden beantwortet spaeter die Frage, welchen erzeugten Text je
 * ein Mensch angefasst hat (Migration 0046).
 */
/*
 * `erzeugt_regel` kam am 16.09.2026 dazu (Migration 0049) und ist weder
 * das eine noch das andere: kein Sprachmodell war beteiligt, und
 * `erfasst` waere die Behauptung, ein Mensch habe den Text geschrieben.
 * Der Unterschied ist nicht buchhalterisch -- ein regelbasierter Text ist
 * REPRODUZIERBAR: dieselben Werte ergeben dieselbe Zeile, heute und in
 * einem Jahr. Wer spaeter fragt, ob ein Text noch zu den Daten passt,
 * muss die beiden Faelle unterscheiden koennen.
 */
export const TEXT_METHODS = ["erfasst", "uebernommen", "uebersetzt_manuell", "uebersetzt_ki",
    "erzeugt_ki", "erzeugt_ki_bearbeitet", "erzeugt_regel"];
/**
 * Bearbeitungsstand einer Sprachfassung.
 *
 * Drei Werte, mehr nicht. "fehlt" ist kein Status -- eine fehlende Fassung ist
 * die Abwesenheit einer Zeile. "uebersetzt" ist kein Status -- das sagt bereits
 * die Entstehungsmethode.
 */
/*
 * `pruefung_noetig` heisst: war freigegeben, die Grundlage hat sich bewegt.
 * Der Weg zurueck fuehrt ueber `geprueft` -- es gibt keinen Sprung auf
 * `freigegeben`, weder von hier noch aus `entwurf` (Migration 0046).
 */
/**
 * Die Entstehungswege, die eine ORIGINALFASSUNG haben kann.
 *
 * Ein Original ist nicht uebersetzt -- und ein erzeugter Text ist keine
 * Uebersetzung, sondern ein Original. Diese Liste stand bis zum 12.09.2026
 * dreimal im Code: zweimal im Server, einmal in der Oberflaeche. Drei Orte
 * fuer eine Regel sind zwei zu viel.
 */
export const TEXT_ORIGINAL_METHODS = ["erfasst", "uebernommen",
    "erzeugt_ki", "erzeugt_ki_bearbeitet",
    "erzeugt_regel"];
export const TEXT_STATUSES = ["entwurf", "geprueft", "freigegeben", "pruefung_noetig"];
/** Auf welcher Ebene ein Text gefuehrt wird. */
export const TEXT_LEVELS = ["article", "family"];
/**
 * Produktmerkmale (Migration 0008).
 *
 * Der Merkmalskatalog selbst steht in der Datenbank, nicht hier -- ein neues
 * Merkmal ist eine eingefuegte Zeile, keine Codeaenderung. Hier stehen nur die
 * geschlossenen Wertevorraete, die das Modell selbst traegt.
 */
/** Wertetypen eines Merkmals. `text` ist die Ausnahme, nicht der Regelfall. */
export const PROPERTY_VALUE_TYPES = ["integer", "decimal", "range", "boolean", "enum", "text"];
/**
 * Vergleichsoperatoren an Punktwerten (Migration 0016).
 *
 * Es gibt bewusst KEIN `eq`: „genau dieser Wert" ist der Normalfall und traegt
 * NULL. Ein Operator fuer den Normalfall haette bedeutet, alle 1351
 * bestehenden Werte anzufassen, um dieselbe Aussage zu treffen.
 *
 * `value_min`/`value_max` bleiben fuer BEREICHE zustaendig. Der Operator gilt
 * nur fuer Punktwerte -- `≤ 24 W` ist ein Bereich ohne Untergrenze, `> 90 Ra`
 * ein Punktwert mit Operator. Das ist kein Widerspruch, sondern die Grenze
 * zwischen „Spanne" und „Schranke".
 */
export const PROPERTY_OPERATORS = ["lt", "le", "gt", "ge"];
/** Das Zeichen zu einem Operator. Sprachneutral -- ein „<" ist ueberall ein „<". */
export const PROPERTY_OPERATOR_SYMBOL = {
    lt: "<", le: "≤", gt: ">", ge: "≥",
};
/**
 * Zustand einer offenen Produktinformation (Migration 0016).
 *
 * Eine offene Information ist eine AUFGABE, kein Wert: sie hat einen
 * Verantwortlichen, ein Datum und einen Zustand. Sie lebt deshalb in
 * `information_requests` und nicht als Leerzeile in `product_properties` --
 * „X", „TBA" und „?" werden nirgends als Datenwert gespeichert.
 */
export const INFORMATION_STATUSES = [
    "offen", "angefragt", "nicht_zutreffend", "bestaetigt",
];
/**
 * Arten der Artikel-zu-Artikel-Beziehung (Migration 0017).
 *
 * `PRODUCT_DATA_MODEL.md` 9 beschreibt sie: „verwendet eine Komponente",
 * „besitzt ein Ersatzteil", „ist Zubehoer fuer ein Produkt". Der Treiber einer
 * Leuchte ist eine `verwendet_komponente`-Beziehung -- und damit KEINE zweite
 * Treiberwahrheit als Textmerkmal (20.11).
 */
export const ARTICLE_RELATION_TYPES = [
    "verwendet_komponente", "ersatzteil_fuer", "zubehoer_fuer",
];
/** Zustand eines Aenderungsvorschlags aus einer externen Quelle. */
export const PROPOSAL_STATUSES = ["offen", "angenommen", "abgelehnt"];
/**
 * Die zentralen Kalkulationsgroessen (Migration 0017).
 *
 * Sie werden versioniert gefuehrt: ein neuer Wechselkurs erzeugt einen neuen
 * Parametersatz, nicht eine Aenderung am alten. Nur so bleibt ein alter
 * Kalkulationsstand lesbar.
 */
/*
 * WAS HIER NEU DAZUGEKOMMEN IST -- und was ausdruecklich NICHT.
 *
 * `usd_eur_safety_discount` ist der Abschlag auf den Referenzkurs (0055). Der
 * KALKULATIONSKURS steht bewusst nicht in dieser Liste: er wird gerechnet und
 * nicht gepflegt -- als eigener Parameter waere er die dritte Zahl, die den
 * beiden anderen widersprechen kann.
 *
 * Die drei Frachtsaetze (0055) gehoeren zu je einer Transportart. `rail_` ist
 * die Bahn und heisst in der Oberflaeche „Train"; der Code bleibt, weil eine
 * Umbenennung elf Dateien und die Bootstrap-Pruefsummen traefe -- fuer eine
 * Zeichenkette, die niemand am Bildschirm sieht.
 *
 * Die drei Abgabensaetze kommen aus 0054: VerpackungsG je Materialart und
 * ElektroG auf dem Produktgewicht.
 */
export const CALCULATION_PARAMETERS = [
    "usd_eur_rate",
    "usd_eur_safety_discount",
    "sea_freight_usd_per_cbm", "rail_freight_usd_per_cbm", "air_freight_usd_per_kg",
    /* Der Volumengewichts-Divisor der Luftfracht (0058) -- ein Parameter und
       keine Konstante: ein anderer Spediteur ist ein neuer Stand. */
    "air_volumetric_divisor_cm3_per_kg",
    "csef_percent",
    "commission_percent", "minimum_margin_percent", "list_price_divisor",
    "rounding_step_eur",
    "packaging_act_cardboard_eur_per_kg", "packaging_act_plastic_eur_per_kg",
    "electro_act_eur_per_kg",
];
/**
 * Die Transportarten einer Kalkulation (Migration 0055).
 *
 * Sie entscheiden, welcher zentrale Frachtsatz gezogen wird. See und Bahn
 * rechnen auf dem Volumen, Luft auf dem Volumengewicht -- das ist nicht
 * dieselbe Formel mit einer anderen Zahl.
 */
export const TRANSPORT_MODES = ["sea", "train", "air"];
/**
 * Parameter, die eine Produktfamilie abweichend fuehren darf (Migration 0018).
 *
 * Die Beschraenkung ist fachlich: Wechselkurs und Zugfracht gelten fuer das
 * ganze Unternehmen, die MINDESTMARGE kann je Familie anders sein. Ein
 * Artikel darf ueberhaupt nicht abweichen -- ausdrueckliche Entscheidung,
 * nicht Vergessen (PRODUCT_PRICE_V1.md 6.8).
 */
/**
 * Die Waehrungen, in denen ein Einkaufspreis erfasst werden kann.
 *
 * ISO-4217-Codes. Sie werden NICHT uebersetzt -- „USD" heisst in jeder
 * Sprache USD. Die Liste steht hier und nicht im Formular, damit eine dritte
 * Waehrung eine Zeile ist und keine Suche durch die Oberflaeche.
 */
export const PRICE_CURRENCIES = ["USD", "EUR"];
/**
 * Alles, was eine vollstaendige Kalkulation braucht.
 *
 * Fehlt eines davon, entsteht kein Listenpreis, und der Kalkulationsstand
 * nennt genau diesen Code als Luecke. Die Liste steht hier, damit die
 * Oberflaeche jede moegliche Luecke BENENNEN kann -- ein roher Code
 * „volume_per_unit" auf dem Bildschirm waere keine Auskunft.
 */
/*
 * ZWEI LUECKEN, DIE KEIN PARAMETER SIND.
 *
 * `product_weight` und `packaging_materials` fehlen am ARTIKEL, nicht im
 * Parametersatz: ohne Produktgewicht kein ElektroG, ohne Materialmengen kein
 * VerpackungsG (0054).
 *
 * `master_dimensions`, `master_gross_weight`, `master_unit_count` fehlen der
 * LUFTFRACHT am Masterkarton (0058): sie rechnet auf dem abrechenbaren
 * Gewicht des versandfertigen Kartons, nicht auf dem Volumen je Stueck.
 * Produktmasse oder Produktgewicht sind kein Ersatz. Bis 0058 stand hier
 * `volumetric_weight_rule` -- die fehlende Regel selbst; sie ist mit dem
 * zentralen Divisor getroffen.
 *
 * `usd_eur_calc_rate` erscheint, wenn der Sicherheitsabschlag den
 * Referenzkurs erreicht: ein Kurs von null oder darunter ist kein Kurs.
 */
export const CALCULATION_INPUTS = [
    "exw", "volume_per_unit", "tariff_code", "duty_rate",
    "product_weight", "packaging_materials",
    "master_dimensions", "master_gross_weight", "master_unit_count",
    "usd_eur_calc_rate",
    ...CALCULATION_PARAMETERS,
];
export const FAMILY_CALCULATION_PARAMETERS = [
    "minimum_margin_percent", "list_price_divisor",
];
/** Gruppierung fuer die Darstellung. */
/*
 * Die Merkmalsgruppen -- die Reihenfolge IST die Lesereihenfolge der
 * Technikansicht.
 *
 * `konformitaet` kam mit 0034 dazu und traegt heute ein einziges Merkmal.
 * Das ist Absicht und kein Versehen: eine Zertifizierung ist eine Aussage
 * ueber eingehaltene Regeln, eine Schutzart eine Eigenschaft des Gehaeuses.
 * Beides unter „Schutz / Qualitaet" zu mischen war fuer drei Werte tragbar
 * und ist es fuer zehn nicht mehr.
 *
 * Diese Liste steht bewusst NEBEN der CHECK-Bedingung `pd_group_chk`. Eine
 * neue Gruppe kostet deshalb beide Stellen -- eine Migration und diese
 * Zeile. Solange Gruppen so selten entstehen wie hier, ist das der
 * billigere Preis gegenueber einer Nachschlagetabelle.
 */
export const PROPERTY_GROUPS = ["lichttechnik", "elektrik", "schutz", "konformitaet", "mechanik", "optik",
    "identitaet"];
/**
 * Die drei Saeulen der technischen Uebersicht.
 *
 * Fuenf Merkmalsgruppen ergeben drei lesbare Spalten. Das ist eine
 * DARSTELLUNGSENTSCHEIDUNG, keine Modelaenderung: `property_definitions.group_code`
 * bleibt unveraendert, die Datenbank kennt diese Spalten nicht.
 *
 * Warum ueberhaupt eine Zuordnung und nicht einfach fuenf Bloecke: `elektrik`
 * traegt heute drei Definitionen, `schutz` und `optik` je drei. Fuenf Bloecke
 * nebeneinander waeren fuenf duenne Streifen. Drei Saeulen tragen den Inhalt
 * und beantworten die Frage, die ein Mensch an ein Leuchtenprodukt stellt:
 * wie leuchtet es, wie wird es betrieben, wie ist es gebaut.
 *
 * Die Zuordnung erfolgt ueber die GRUPPE, nie ueber einen Merkmalscode. Ein
 * neues Merkmal folgt dadurch automatisch seiner Gruppe -- die Oberflaeche
 * muss dafuer nicht angefasst werden (P12).
 */
export const PROPERTY_COLUMNS = ["licht", "strom", "bau"];
export const PROPERTY_COLUMN_OF = {
    lichttechnik: "licht",
    // Der Abstrahlwinkel ist die einzige heute belegte Definition dieser Gruppe
    // und gehoert fachlich zum Licht. Traegt `optik` spaeter Sensorik oder
    // Notlichtdauer, ist die Zuordnung neu zu bewerten -- offener Punkt.
    optik: "licht",
    elektrik: "strom",
    mechanik: "bau",
    schutz: "bau",
    // Zertifizierungen und Konformitaeten sind weder Licht noch Strom. Sie
    // standen bis 0034 in `schutz` und damit in dieser Saeule -- sie bleiben,
    // wo der Leser sie kennt. Die Trennung von `schutz` ist eine Entscheidung
    // fuer die TECHNIKANSICHT; diese drei Saeulen sind eine andere Ansicht mit
    // einer anderen Frage, und dort waere eine vierte Saeule fuer ein Merkmal
    // die duenne Spalte, die diese Zuordnung gerade vermeidet.
    konformitaet: "bau",
    // Die Herstellermarke (0098) ist weder Licht noch Strom noch Bauart. Sie
    // steht hier durch AUSSCHLUSS, nicht durch Passung -- und das ist
    // dieselbe Abwaegung wie bei `konformitaet` eine Zeile hoeher: eine
    // vierte Saeule fuer ein einziges Merkmal waere die duenne Spalte, die
    // diese Zuordnung gerade vermeidet.
    //
    // OFFENER PUNKT, wie bei `optik`: sobald `identitaet` mehr als diese eine
    // Definition traegt, ist die Zuordnung neu zu bewerten. Die drei Saeulen
    // beantworten eine technische Frage; eine Identitaetsangabe beantwortet
    // eine kaufmaennische. Das kann eine eigene Stelle verlangen -- aber erst,
    // wenn es dort etwas zu zeigen gibt.
    identitaet: "bau",
};
/*
 * KEIN WERT = KEINE ZEILE.
 *
 * Hier stand bis V1 `PROPERTY_COLUMN_PLANNED` -- eine Liste von Angaben, die
 * im Layout einen Platz haben sollten, bevor es sie gibt (Treiberhersteller,
 * Steuerung, Spannung, Verdrahtung, Leuchten je LS, Umgebungstemperatur,
 * Lebensdauer). Sie erschienen als leise „Vorgesehen"-Zeile in der
 * Produktuebersicht.
 *
 * Sie ist entfernt: welche Felder HOMEBASE spaeter einmal enthalten soll, ist
 * eine Entwicklungsinformation und keine Produktinformation. Sobald eine
 * dieser Angaben eine Merkmalsdefinition bekommt, erscheint sie automatisch
 * in ihrer Saeule -- die Zuordnung folgt der Gruppe, nicht einer Liste.
 *
 * „Leuchten je LS" bleibt davon unberuehrt als fachlich verbindlicher
 * Datentyp offen; das ist eine Modellfrage und keine Layoutfrage.
 */
/**
 * Herkunft eines Wertes -- WOHER er stammt.
 *
 * Bewusst derselbe Wertevorrat wie bei den Sprachfassungen, und bewusst
 * dieselbe Liste statt einer zweiten mit gleichem Inhalt: so koennen beide
 * nicht auseinanderlaufen.
 */
export const PROPERTY_ORIGINS = TEXT_ORIGINS;
/**
 * Entstehungsweise eines Wertes -- WIE er entstand.
 *
 * Hier weicht der Vorrat von dem der Texte ab, und das ist fachlich richtig:
 * ein Merkmal wird nicht uebersetzt, sondern erfasst, uebernommen, aus
 * Freitext extrahiert oder aus einem anderen Wert abgeleitet.
 *
 * `extrahiert` und `abgeleitet` sind die beiden, die spaeter zaehlen: ein
 * maschinell gewonnener Wert muss von einem erfassten unterscheidbar bleiben.
 */
export const PROPERTY_METHODS = ["erfasst", "uebernommen", "extrahiert", "abgeleitet"];
/**
 * Die Befundklassen der fachlichen Merkmalspruefung.
 *
 * Sie sind NICHT der Qualitaetsstatus und duerfen ihn nicht ersetzen. Ein
 * Befund sagt, was die Auswertung gesehen hat; der Status sagt, was ein
 * Mensch bestaetigt hat. Ein Wert mit Befund A ist ein sehr sicherer
 * Bestaetigungskandidat -- und bleibt `pruefung_erforderlich`, bis jemand mit
 * `property.confirm` ihn bestaetigt.
 */
export const PROPERTY_FINDING_CLASSES = ["A", "B", "C", "D", "E", "F"];
/**
 * Die moeglichen Befundgruende -- eine GESCHLOSSENE Liste.
 *
 * Sie steht hier und nicht im Auswertungswerkzeug, damit Werkzeug und
 * Woerterbuch nicht auseinanderlaufen koennen: ein Grund, den das Werkzeug
 * meldet und die Oberflaeche nicht beschriften kann, waere ein roher Code auf
 * dem Bildschirm. Die Pruefung in `checki18n` haelt beide zusammen.
 */
export const PROPERTY_FINDING_CODES = [
    // A · zweite Quelle traegt dieselbe Aussage
    "dte_bestaetigt",
    // B · formal in Ordnung, aber ohne tragende Zweitquelle
    "keine_zweitquelle", "zweitquelle_schweigt", "zweitquelle_ungenauer",
    "nicht_maschinell_nachpruefbar", "quelle_nennt_weitere_lichtfarben",
    // C · Wert gibt sein eigenes Quellsegment nicht wieder
    "abweichung_erstquelle",
    // D · zwei Quellen sagen Verschiedenes
    "dte_konflikt",
    // E · Aussage vorhanden, Modell kann sie nicht tragen
    "winkel_asymmetrisch", "cri_schwelle", "leistung_geteilt", "leistung_stufen",
    "ausschnitt_zweiachsig", "dte_nicht_abbildbar",
    // F · Fehler in der Quelle selbst
    "flaecheneinheit_bei_laenge", "einheit_doppelt", "kelvin_mit_schranke",
];
/** Die fuenf Lichtfarbencodes. Sprachneutral; die Anzeige liefert das Woerterbuch. */
export const LIGHT_COLOUR_CODES = ["ww+", "ww", "nw", "tl", "tl+"];
/**
 * Die verbindliche greenius-Zuordnung von Lichtfarbe zu Farbtemperatur.
 *
 * Sie ist ABSICHTLICH nicht umkehrbar. Nur `nw` ist eindeutig; alle anderen
 * Codes decken zwei zulaessige Kelvinwerte ab.
 */
export const LIGHT_COLOUR_CCT = {
    "ww+": [2200, 2500],
    "ww": [2700, 3000],
    "nw": [4000],
    "tl": [5000, 5700],
    "tl+": [6000, 6500],
};
/**
 * Farbtemperatur → Lichtfarbe. Diese Richtung ist immer zulaessig.
 *
 * Ein konkreter Kelvinwert bestimmt seine Lichtfarbe eindeutig; ein Wert, der
 * zu keiner gehoert, liefert `null` statt einer geratenen Zuordnung.
 */
export function cctToLightColour(cct) {
    for (const code of LIGHT_COLOUR_CODES) {
        if (LIGHT_COLOUR_CCT[code].includes(cct))
            return code;
    }
    return null;
}
/**
 * Lichtfarbe → Farbtemperatur. Diese Richtung ist NUR fuer `nw` zulaessig.
 *
 * Das ist der Kern der Regel: aus `ww` liesse sich 2700 oder 3000 machen --
 * und welche der beiden, weiss niemand. Einen der Werte zu waehlen waere
 * erfundene Praezision. Deshalb `null` fuer alles ausser `nw`.
 */
export function lightColourToCct(code) {
    const values = LIGHT_COLOUR_CCT[code];
    return values.length === 1 ? values[0] : null;
}
/**
 * Kurzform einer Farbtemperatur fuer die Anzeige: 4000 → "4K", 5700 → "5.7K".
 *
 * Reine Darstellung. Sie wird NICHT gespeichert -- ein abgeleiteter Wert
 * bekommt keine Spalte, in der er falsch stehen bleiben koennte.
 */
export function formatCct(cct) {
    const k = cct / 1000;
    return `${Number.isInteger(k) ? k : k.toFixed(1)}K`;
}
/**
 * Startqualitaet eines Merkmalswerts aus seiner Entstehungsweise.
 *
 * Der Grundsatz in einem Satz: maschinelle Extraktion ist keine fachliche
 * Bestaetigung. Ein eindeutig erkannter String kann technisch sicher
 * gewonnen und fachlich trotzdem ungeprueft sein.
 *
 * `belastbar` entsteht hier NIE -- dieser Status ist ausschliesslich das
 * Ergebnis eines menschlichen Schritts mit eigenem Recht.
 *
 * Die Funktion steht bewusst in `shared`: Fachkern und Extraktionswerkzeug
 * benutzen dieselbe Implementierung, nicht zwei gleichlautende.
 */
export function initialPropertyQuality(method) {
    return method === "extrahiert" || method === "abgeleitet" ? "pruefung_erforderlich" : "warnung";
}
/**
 * Produktmodell- und Variantenebene (Migration 0010).
 *
 * Fachliche Quelle: PRODUCT_DATA_MODEL.md, Abschnitte 2, 3, 22 und 23.
 * Diese Datei erfindet keine Werte -- sie bildet die entschiedenen ab.
 */
/**
 * Auf welcher Ebene ein Text oder Merkmal gefuehrt wird.
 *
 * Erweitert `TEXT_LEVELS` um das Produktmodell. Bewusst eine eigene Liste
 * statt einer Aenderung an `TEXT_LEVELS`: `hinweis` bleibt auf Artikel und
 * Familie beschraenkt, und die Ebenen eines Texttyps stehen ohnehin in der
 * Datenbank.
 */
export const SUBJECT_LEVELS = ["article", "family", "model"];
/**
 * Beziehung einer SKU zum operativen ERP (PRODUCT_DATA_MODEL.md 22.3).
 *
 * Der Status sagt NICHTS ueber Fokus, Bestand, Sortimentsklasse,
 * Preislistenfreigabe oder Lebenszyklus. `fehlgeschlagen` ist ausdruecklich
 * kein Endzustand.
 */
export const DTE_LISTING_STATUSES = [
    "nicht_gelistet",
    "vorgemerkt",
    "gelistet",
    "fehlgeschlagen",
];
/**
 * Zulaessige Statusuebergaenge der DTE-Listung.
 *
 * Eine Tabelle statt verstreuter Bedingungen -- so ist an einer Stelle
 * lesbar, dass `fehlgeschlagen` nach `vorgemerkt` zurueckkehren kann und dass
 * eine Listung nicht ohne Vormerkung entsteht.
 *
 * Die fachliche Regel dahinter (22.4): der Listungsvorgang ist die einzige
 * Tuer, und sie wird von einem Menschen geoeffnet.
 */
export const DTE_TRANSITIONS = {
    nicht_gelistet: ["vorgemerkt"],
    vorgemerkt: ["gelistet", "fehlgeschlagen", "nicht_gelistet"],
    gelistet: ["nicht_gelistet"],
    fehlgeschlagen: ["vorgemerkt", "nicht_gelistet"],
};
/** Ist dieser Uebergang zulaessig? Gleicher Stand auf beiden Seiten der API-Grenze. */
export function isDteTransitionAllowed(from, to) {
    return from === to || DTE_TRANSITIONS[from].includes(to);
}
export function matrixShape(freeDimensions) {
    if (freeDimensions <= 1)
        return "liste";
    if (freeDimensions === 2)
        return "matrix";
    return "gruppiert";
}
/**
 * Logistik und Verpackung (Migration 0012).
 *
 * Fachliche Quelle: Auftrag „Logistik & Beschaffung V1", Teil 1.
 * Diese Datei erfindet keine Werte -- sie bildet die entschiedenen ab.
 *
 * Die Wertevorraete stehen ZUSAETZLICH in Nachschlagetabellen. Das ist keine
 * Verdopplung mit zwei Wahrheiten: die Datenbank bleibt die Quelle, hier steht
 * der geschlossene Stand, gegen den `checki18n` prueft, dass jeder Code eine
 * Beschriftung in beiden Sprachen besitzt.
 */
/**
 * Die deklarierten Verpackungsebenen.
 *
 * `inner` ist OPTIONAL. Ihr Fehlen ist kein Mangel, kein Fehler und kein
 * Prueffall. `master` bezeichnet die relevante aeussere Versand- und
 * Logistikeinheit -- nicht zwingend einen Sammelkarton mit mehreren Stueck.
 *
 * `pallet` kam mit 0079 dazu -- genau so, wie es hier angekuendigt war:
 * eine Zeile in `packaging_level_types` und ein Eintrag hier. Sie ist
 * ebenso OPTIONAL wie `inner`; eine Sendung ohne Palettierung ist kein
 * unvollstaendiger Verpackungsstand.
 */
export const PACKAGING_LEVEL_TYPES = ["inner", "master", "pallet"];
/**
 * Warum ein neuer Verpackungsstand entstand.
 *
 * Das ist die VERPACKUNGShistorie -- „welche Verpackung galt?". Die
 * geschaeftliche Entscheidungshistorie -- „warum haben wir sie aendern
 * lassen?" -- ist eine andere Achse und wird hier nicht vermischt.
 */
export const PACKAGING_CHANGE_REASONS = [
    "initial",
    "product_change",
    "complaint",
    "optimization",
    "supplier_change",
    "other",
];
/**
 * Wer die Verpackung eines Verpackungsstands bereitstellt.
 *
 * Ausdruecklich KEINE Kosteninformation. Verpackungskosten, Supplierpreis-
 * anteile und Cost Components gehoeren zur Preis- und Kalkulationslogik.
 */
export const PACKAGING_PROVIDERS = ["supplier", "greenius", "mixed"];
/** Verpackungsmaterialien. Zentral gefuehrt -- Vera fuehrt keine zweite Liste. */
export const PACKAGING_MATERIALS = ["cardboard", "plastic", "wood", "other"];
/** Arten eines Verpackungsnachweises. V1: der Falltest. */
export const PACKAGING_TEST_TYPES = ["drop_test"];
/**
 * Ergebnis eines Verpackungsnachweises.
 *
 * `open` ist ein Zustand, keine Luecke: ein vereinbarter, aber noch nicht
 * durchgefuehrter Nachweis ist etwas anderes als ein fehlender.
 *
 * Ein bestandener Nachweis sagt NICHTS ueber die Volumeneffizienz der
 * Verpackung. Verpackungsqualitaet und Datenqualitaet bleiben getrennt.
 */
export const PACKAGING_TEST_RESULTS = ["passed", "failed", "open"];
/**
 * Herkunft und Entstehungsweise einer Logistikangabe.
 *
 * Bewusst dieselben Listen wie bei Texten und Merkmalen, nicht zwei weitere
 * mit gleichem Inhalt: so koennen sie nicht auseinanderlaufen. Es entsteht
 * KEINE parallele Statuswelt neben `quality_statuses`.
 */
export const LOGISTICS_ORIGINS = TEXT_ORIGINS;
export const LOGISTICS_METHODS = PROPERTY_METHODS;
/**
 * Startqualitaet einer Logistikangabe -- dieselbe Regel wie bei den Merkmalen
 * und ausdruecklich dieselbe Implementierung.
 *
 * `belastbar` entsteht dadurch NIE. Dieser Status ist ausschliesslich das
 * Ergebnis eines menschlichen Schritts mit eigenem Recht (`logistics.confirm`).
 */
export const initialLogisticsQuality = initialPropertyQuality;
/**
 * Darstellung eines Kubikmeterwerts.
 *
 * **Rundung ist ausschliesslich Darstellung.** Gespeichert wird der exakte,
 * aus den Aussenmassen berechnete Wert; diese Funktion erzeugt daraus eine
 * lesbare Zahl und niemals einen zweiten gespeicherten Wert.
 *
 * `null` bleibt `null`: fehlt die Masterebene, ist das CBM UNBEKANNT. Es wird
 * hier nicht zu 0,000000 (HOMEBASE_ARCHITECTURE.md 7.6).
 */
export function formatCbm(value, fractionDigits = 6) {
    if (value === null || value === undefined || value === "")
        return null;
    const n = Number(value);
    return Number.isFinite(n) ? n.toFixed(fractionDigits) : null;
}
//# sourceMappingURL=domain.js.map